import { apiClient } from "./apiClient";

export const adminService = {
  // Clear chats database
  clearChatsDatabase: async () => {
    try {
      const response = await apiClient.delete("/admin/chats-database/clear-chats-database");
      return response.data;
    } catch (error) {
      console.error("Error clearing chats database:", error);
      return { error: "Error clearing chats database" };
    }
  },

  // Get all knowledge document summaries
  getAllKnowledgeDocumentSummaries: async () => {
    try {
      const response = await apiClient.get(
        "/admin/knowledge-base/get-all-knowledge-document-summaries"
      );
      return response.data;
    } catch (error) {
      console.error("Error getting all knowledge document summaries:", error);
      return { error: "Error getting all knowledge document summaries" };
    }
  },

  // Create knowledge document
  createOrUpdateKnowledgeDocument: async (knowledgeDocument) => {
    try {
      const response = await apiClient.post(
        "/admin/knowledge-base/create-or-update-knowledge-document",
        knowledgeDocument
      );
      return response.data;
    } catch (error) {
      console.error("Error creating knowledge document:", error);
      return { error: "Error creating knowledge document" };
    }
  },

  // Get knowledge document by id
  getKnowledgeDocumentById: async (knowledgeDocumentId) => {
    try {
      const response = await apiClient.get(
        `/admin/knowledge-base/get-knowledge-document-by-id?knowledgeDocumentId=${knowledgeDocumentId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error getting knowledge document by id:", error);
      return { error: "Error getting knowledge document by id" };
    }
  },

  // Delete knowledge document by id
  deleteKnowledgeDocumentById: async (knowledgeDocumentId) => {
    try {
      const response = await apiClient.delete(
        `/admin/knowledge-base/delete-knowledge-document-by-id?knowledgeDocumentId=${knowledgeDocumentId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error deleting knowledge document by id:", error);
      return { error: "Error deleting knowledge document by id" };
    }
  },

  // Get agent instructions
  getAgentInstructions: async (agent) => {
    try {
      const response = await apiClient.get(
        `/admin/agents/get-agent-instructions?agentNumber=${agent}`
      );

      return response.data;
    } catch (error) {
      console.error("Error getting agent instructions:", error);
      return { error: "Error getting agent instructions" };
    }
  },

  // Update agent instructions
  updateAgentInstructions: async (agentNumber, instructions) => {
    try {
      const response = await apiClient.post(`/admin/agents/update-agent-instructions`, {
        agentNumber: parseInt(agentNumber),
        instructions,
      });
      return response.data;
    } catch (error) {
      console.error("Error updating agent instructions:", error);
      // Log the full error response
      if (error.response) {
        console.error("Error response:", error.response.data);
      }
      return { error: "Error updating agent instructions" };
    }
  },
};
